export default () => ({
    redirect(e) {
        e.preventDefault();
        const url = e.currentTarget.getAttribute('data-url');
        if (url !== null) {
            window.open(url, '_blank');
        }
    }
})
